import dayjs from 'dayjs';

export default function WeekStrip({ dateIso, onSelect }) {
	const selected = dayjs(dateIso);
	const weekStart =
		selected.day() === 0 ? selected.subtract(6, 'day') : selected.startOf('week').add(1, 'day');
	const days = Array.from({ length: 7 }, (_, i) => weekStart.add(i, 'day'));
	const selectedKey = selected.format('YYYY-MM-DD');

	return (
		<div className='days' role='listbox' aria-label='Meal week'>
			{days.map((d) => {
				const iso = d.format('YYYY-MM-DD');
				const pressed = iso === selectedKey;
				return (
					<button
						key={iso}
						type='button'
						role='option'
						aria-selected={pressed}
						className={pressed ? 'selected' : undefined}
						onClick={() => onSelect?.(iso)}
					>
						<span>{d.format('ddd')}</span>
						<b>{d.format('D')}</b>
						{pressed ? <span className='dot' aria-hidden='true' /> : <span className='dot-space' aria-hidden='true' />}
					</button>
				);
			})}
		</div>
	);
}
